import React, { memo, ReactElement } from 'react';

import { Col, Divider, Row, TypographyText } from '@components/atoms';
import { useReduxForm } from '@hooks/useReduxForm';

function Scale({ value }: { value: string }): ReactElement {
  const { formData, setFormData } = useReduxForm('survey');

  return (
    <Row style={{ width: '100%', alignItems: 'center', justifyContent: 'center', marginBlock: '6px' }}>
      <Row
        justify="space-between"
        style={{
          width: '100%',
          maxWidth: '292px',
        }}
      >
        {[1, 2, 3, 4, 5].map((e) => (
          <Col
            key={e}
            onClick={() => {
              setFormData({ [value]: { ...(formData[value] ?? {}), scale: e } });
            }}
            style={{ cursor: 'pointer' }}
          >
            <img
              alt={`scale-${e}`}
              src={`${process.env.PUBLIC_URL}/img/scale-${e}-${
                formData[value]?.scale === e ? 'b' : 'a'
              }.webp`}
              width="52px"
            />
          </Col>
        ))}
      </Row>
      <Row
        justify="space-between"
        style={{ width: '100%', maxWidth: '292px', position: 'relative' }}
        yzTypeRow="center"
      >
        <Col style={{ width: '58px' }}>
          <Divider margin={6} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
          <Row>
            <Col yzTypeCol="center">
              <Row yzTypeRow="center">
                <Col yzTypeCol="center">
                  <TypographyText yzTypeTypographyText="scale">조금</TypographyText>
                </Col>
              </Row>
              <Row>
                <Col yzTypeCol="center">
                  <TypographyText yzTypeTypographyText="scale">불편해요</TypographyText>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col
          style={{
            position: 'absolute',
            border: '1px solid #E5E5E5',
            width: 'calc(178px + calc(calc(100% - 300px) / 2))',
            top: '57%',
            left: 'calc(61px + calc(calc(100% - 300px) / 4))',
          }}
        />
        <Col style={{ width: '58px' }}>
          <Divider margin={6} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
          <Row>
            <Col yzTypeCol="center">
              <Row yzTypeRow="center">
                <Col yzTypeCol="center">
                  <TypographyText yzTypeTypographyText="scale">매우</TypographyText>
                </Col>
              </Row>
              <Row>
                <Col yzTypeCol="center">
                  <TypographyText yzTypeTypographyText="scale">불편해요</TypographyText>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Row>
  );
}

export default memo(Scale);
